import { render, staticRenderFns } from "./orderData.vue?vue&type=template&id=9b4715a0&scoped=true"
import script from "./orderData.vue?vue&type=script&lang=js"
export * from "./orderData.vue?vue&type=script&lang=js"
import style0 from "./orderData.vue?vue&type=style&index=0&id=9b4715a0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4715a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b4715a0')) {
      api.createRecord('9b4715a0', component.options)
    } else {
      api.reload('9b4715a0', component.options)
    }
    module.hot.accept("./orderData.vue?vue&type=template&id=9b4715a0&scoped=true", function () {
      api.rerender('9b4715a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/logisticsSystem/stockManagement/dataQuery/orderData.vue"
export default component.exports